module.exports = __webpack_public_path__ + "img/home-btn-email.988c0af3.svg";